import { render, staticRenderFns } from "./GetStartedProd.vue?vue&type=template&id=39f662fe&scoped=true"
import script from "./GetStartedProd.vue?vue&type=script&lang=js"
export * from "./GetStartedProd.vue?vue&type=script&lang=js"
import style0 from "./GetStartedProd.vue?vue&type=style&index=0&id=39f662fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f662fe",
  null
  
)

export default component.exports